<template>
	<div id="elmmarket" style="margin-top: 67px;">
		<div class="focuImg" ref="element">
			<div>
				<img src="/static/img/img_banner.png" alt="" style="width: 100%;" />
			</div>
		</div>
		<div>

		</div>
		<div class="TopNav" v-if="navBarFixed == true" :class="navBarFixed == true ? 'navBarWrap' :''">

			<div style="display: flex;margin-left: 28px;">
				<img src="../../static/img/home_img_logo1.png" class="logo" alt="">
				<div class="logo_line"></div>
				<div class="nav_intro">
					<span>国家高新技术企业</span><br>
					<span>全栈追溯技术服务商</span>
				</div>
				<div class="logo_line" style="margin-left: 20px;"></div>
			</div>
			<div style="display: flex;margin-right: 28px;">
				<!--<img src="../../static/img/elm.png" class="logo1" alt="">
				<img src="../../static/img/kb.png" class="logo1" alt="">-->
					<img src="../../static/img/albdsh.png"   alt="">
			</div>

		</div>

		<div class="wh">
			<p>饿了么数字化菜场</p>
			<p>是阿里本地生活官方授权并指导实施的</p>
			<p>现代化智慧菜场，通过阿里本地化生活商业操作系统</p>
			<p>在农贸市场场景的落地应用，</p>
			<p>帮助菜场实现数字化、网络化、可视化，</p>
			<p>配合政府部门“五化”落地并提供</p>
			<p>全方位的解决方案。</p>
		</div>
		<div class="jjfa">
			<div>
				<p class="title">解决方案</p>
				<div class="flex" style="align-items:center;">
					<div class="item">
						<img src="../../static/img/icon_solution_1.png" />
						<p>饿了么数字化菜场品牌授权，品牌自带流量，提升菜场品牌公信力</p>
					</div>
					<div class="item">
						<img src="../../static/img/icon_solution_2.png" />
						<p>饿了么菜场专项补贴政策，打造3公里菜场生态圈，30分钟即可到家</p>
					</div>
					<div class="item">
						<img src="../../static/img/icon_solution_3.png" />
						<p>AI识别，智能提效，解放商户生产力，打造”未来菜场”</p>
					</div>
					<div class="item">
						<img src="../../static/img/icon_solution_4.png" />
						<p>融合支付宝平台能力，定制菜场专属营销方案</p>
					</div>
				</div>
				<p class="title">阿里本地生活-智慧菜场操作系统</p>
				<div class="zhcz1">
					<div class="zhcz">
						<div class="dzc">
							<img src="../../static/img/img_dzc.png" />
							<div class="line"></div>
						</div>
						<p>10.1英寸高清客显屏</br>(1280×800)</p>
						<p>58mm票据打印机</p>
						<p>水平气泡</p>
						<p>立杆</p>
						<p>7英寸高清一体式电阻触摸屏</br>
							(800×480)</p>
						<p>不锈钢秤盘</p>
						<p>电源指示符号和</br>
							充电指示符号</p>
						<p>19个硬件按键</p>
					</div>
					<p class="title1" style="margin-bottom: 70px;">核心优势</p>
					<div>
						<div class="row flexb">
							<div class="hxitem">
								<div class="flex hxitemtop">
									<img src="../../static/img/icon_coreadvantage_1.png" /> 高度集成
								</div>
								<div class="flex hxitembottom">
									<div class="flex">
										<div class="yuan"></div>
										<div>打印机</div>
									</div>
									<div class="flex">
										<div class="yuan"></div>
										<div>音箱</div>
									</div>
								</div>
								<div class="flex hxitembottom">
									<div class="flex">
										<div class="yuan"></div>
										<div>称重</div>
									</div>
									<div class="flex">
										<div class="yuan"></div>
										<div>副屏被扫等</div>
									</div>
								</div>
							</div>
							<div class="hxitem">
								<div class="flex hxitemtop">
									<img src="../../static/img/icon_coreadvantage_2.png" /> 图像识别
								</div>
								<div class="flex hxitembottom">
									<div class="flex">
										<div class="yuan"></div>
										<div>AI拍照</div>
									</div>
									<div class="flex">
										<div class="yuan"></div>
										<div>自动补光</div>
									</div>
								</div>
								<div class="flex hxitembottom">
									<div class="flex">
										<div class="yuan"></div>
										<div>订单图像追溯</div>
									</div>

								</div>
							</div>
						</div>
						<div class="row flexb">
							<div class="hxitem">
								<div class="flex hxitemtop">
									<img src="../../static/img/icon_coreadvantage_3.png" /> 防水防虫
								</div>
								<div class="flex hxitembottom">
									<div class="flex">
										<div class="yuan"></div>
										<div>整机防水溅IP56</div>
									</div>

								</div>
								<div class="flex hxitembottom">
									<div class="flex">
										<div class="yuan"></div>
										<div>主板密封防虫设计</div>
									</div>

								</div>
							</div>
							<div class="hxitem">
								<div class="flex hxitemtop">
									<img src="../../static/img/icon_coreadvantage_4.png" /> 离线收银
								</div>
								<div class="flex hxitembottom">
									<div class="flex" style="width: 100%;">
										<div class="yuan"></div>
										<div>断电断网也能正常是使用</div>
									</div>

								</div>

							</div>
						</div>
					</div>

				</div>
				<div class="dp">
					<img src="../../static/img/img_bigdatascreen.png" />
				</div>
			</div>
		</div>
		<div class="fw">
			<p class="title1" style="margin-bottom: 70px;font-size: 34px;height: 34px;">360°全方位一站式服务</p>
			<div class="flex" style="margin: 0 auto;width: 1090px;">
				<div class="fwitem">
					<img src="../../static/img/img_business_2.png" alt="">
					<p class="t">业务支持</p>
					<p class="con">专属合作伙伴拓展经理提供业务支持和商务支持，帮助您在“产品质量安全信息化体系”领域取得成功。</p>
				</div>
				<div class="fwitem">
					<img src="../../static/img/img_train_3.png" alt="">
					<p class="t">培训支持</p>
					<p class="con">为了用户更好的了解使用产品，安宣信息提供包括现场指导培训等多种服务。
					</p>
				</div>
				<div class="fwitem">
					<img src="../../static/img/img_technology_4.png" alt="">
					<p class="t">专业技术支持</p>
					<p class="con">专项技术领域获得浙江安宣专业团队的技术支持，在垂直市场获得领先优势。</p>
				</div>
			</div>
		</div>
		<div class="bottom">
			现在联系我们，即可为您定制数字化菜场方案！
		</div>
		<div class="footerbox" ref="e">
			<div class="mddw" id="e"></div>
			<div class="footerboxTop">
				<div class="list1">
					<p class="p1">联系我们</p>
					<div class="xian"></div>
					<p class="p2">服务热线</p>
					<p class="p3">0571-87357305</p>
					<p class="p2">公司邮箱</p>
					<p class="p3">zjax@ansuw.com</p>
				</div>
				<div class="list2">
					<p class="p1">产品服务</p>
					<div class="xian"></div>
					<p class="p1" style="line-height: 45px;margin: 0;">软件产品</p>
					<div style="display: flex;flex-wrap: wrap;">
						<a href="http://www.ax168.com/system?activeIndex=0">食品追溯系统</a>
						<a href="http://www.ax168.com/system?activeIndex=1">食品检测系统</a>
						<a href="http://www.ax168.com/system?activeIndex=2">市场运营系统</a>
						<a href="http://www.ax168.com/system?activeIndex=3">商家管理系统</a>
						<a href="http://www.ax168.com/system?activeIndex=4">会员营销系统</a>
						<a href="http://www.ax168.com/system?activeIndex=5">网上菜场系统</a>
						<a href="http://www.ax168.com/system?activeIndex=6">市场招商系统</a>
						<a href="http://www.ax168.com/system?activeIndex=7">电子结算系统</a>
						<a href="http://www.ax168.com/system?activeIndex=8">智能巡查系统</a>
						<a href="http://www.ax168.com/system?activeIndex=9">数据展示系统</a>
						<a href="http://www.ax168.com/system?activeIndex=10">智慧农场系统</a>
						<a href="http://www.ax168.com/system?activeIndex=11">智慧禽畜系统</a>
						<a href="http://www.ax168.com/system?activeIndex=12">智慧水产系统</a>
					</div>
					<p class="p1" style="line-height: 45px;margin: 0;">硬件产品</p>
					<div style="display: flex;flex-wrap: wrap;">
						<a>智慧农贸追溯电子秤</a>
						<a>商户信用公示屏</a>
						<a>放心农贸触摸一体机</a>
						<a>数据大屏</a>
					</div>
				</div>
				<div class="list3">
					<p class="p1">关于我们</p>
					<div class="xian"></div>
					<p class="p2">
						<a href="http://www.ax168.com/about/#a">企业简介</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#b">企业优势</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#c">资质荣誉</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#d">企业特色</a>
					</p>
				</div>
			</div>
			<div class="footerboxC">
				<div class="xian"></div>
				<div class="textList">
					<p>解决方案</p>
					<p>
						<a href="http://www.ax168.com/publicity">智慧农贸解决方案</a>
					</p>
					<p>
						<a href="http://www.ax168.com/ygst">阳光厨房解决方案</a>
					</p>
					<p>
						<a href="http://www.ax168.com/zycpzs">重要产品追溯解决方案</a>
					</p>
				</div>
				<div class="xian"></div>
			</div>
			<div class="footerboxb">
				<p>地址： 浙江省杭州市西湖区西园八路11号一期D座506-507</p>
				<p>浙ICP备15019865号-1</p>
				<p>公安部备案号：33010602001517</p>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.min.css'
	export default {
		data() {
			return {
				navBarFixed: false,
				gengduo: false,
				TopNav: 1,
				anli: [{
					name: '山东省富硒甜瓜',
					src: '/static/img/img_Shandongmelon_1.png'
				}, {
					name: '山东省沙瓤西红柿',
					src: '/static/img/img_Shandongtomato_2.png'
				}, {
					name: '山东省彩虹西瓜',
					src: '/static/img/img_Shandongwatermelon_3.png'
				}, {
					name: '河南省滑县道口义祥张烧鸡',
					src: '/static/img/img_Henanroastchicken_4.png'
				}, {
					name: '陕西榆林沙地红薯',
					src: '/static/img/img_Yulinsweetpotato.png'
				}, {
					name: '海南省桥头地瓜',
					src: '/static/img/img_Hainansweetpotato_6.png'
				}],
				dataShow: [{
						text: '多年技术沉淀  通过双软认证',
						count: 10,
						start: 0,
						timer: ''
					},
					// {text: '数十项软件著作权 国家高新技术企业',count: 20,start: 0,timer: ''},
					{
						text: '多项软件著作权  国家高新技术企业',
						count: 20,
						start: 0,
						timer: ''
					},
					{
						text: '超强技术团队  获评大数据企业',
						count: 100,
						start: 0,
						timer: ''
					}, {
						text: '追溯系统覆盖一万多家大中型商超、批发配送企业',
						count: 10000,
						start: 9800,
						timer: ''
					}
				],
				fuwu: [{
					name: '业务支持',
					src: '/static/img/img_business_1.png',
					text: '专属合作伙伴拓展经理提供业务支持和商务支持，帮助您在“产品质量安全信息化体系”领域取得成功。'
				}, {
					name: '培训支持',
					src: '/static/img/img_train_2.png',
					text: '为了用户更好的了解使用产品，安宣信息提供包括现场指导培训等多种服务。'
				}, {
					name: '专业技术支持',
					src: '/static/img/img_technology_3.png',
					text: '专项技术领域获得浙江安宣专业团队的技术支持，在垂直市场获得领先优势。'
				}]
			}
		},
		created: function() {
			this.$emit('footer', false);
			this.$emit('footer1', false);
			this.$emit('footer2', true);

		},
		activated() {
			document.title = "安宣智慧农贸-智慧农贸方案-安宣农贸解决方案"
			document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
		},
		methods: {
			getData() {
				var t = this;
				this.dataShow[0].timer = setInterval(function() {
					if(t.dataShow[0].start < t.dataShow[0].count) {
						t.dataShow[0].start = t.dataShow[0].start + 1;
					} else {
						clearInterval(t.dataShow[0].timer);
					}
				}, 150)
				this.dataShow[1].timer = setInterval(function() {
					if(t.dataShow[1].start < t.dataShow[1].count) {
						t.dataShow[1].start = t.dataShow[1].start + 1;
					} else {
						clearInterval(t.dataShow[1].timer);
					}
				}, 5)
				this.dataShow[2].timer = setInterval(function() {
					if(t.dataShow[2].start < t.dataShow[2].count) {
						t.dataShow[2].start = t.dataShow[2].start + 1;
					} else {
						clearInterval(t.dataShow[2].timer);
					}
				}, 15)
				this.dataShow[3].timer = setInterval(function() {
					if(t.dataShow[3].start < t.dataShow[3].count) {
						t.dataShow[3].start = t.dataShow[3].start + 1;
					} else {
						clearInterval(t.dataShow[3].timer);
					}
				}, 4)
			},
			goAnchor(selector) {
				this.$el.querySelector(selector).scrollIntoView({
					behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				});
			},
			watchScroll() {
				var scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				let height = this.$refs.element.offsetHeight

				if(scrollTop > height) {
					this.navBarFixed = true;
				} else {
					this.navBarFixed = false;
				}

			}
		},

		mounted() {
			//banner轮播		
			//			var swiper = new Swiper('.bannerimg', {
			//				pagination: '.swiper-pagination',
			//				paginationClickable: true,
			//				centeredSlides: true,
			//				autoplay: 3000,
			//				autoplayDisableOnInteraction: false,
			//				speed: 800,
			//				loop: true,
			//				// initialSlide: 3,
			//			})
			//			// 鼠标悬停控制轮播
			//			var comtainer = document.getElementById('bannerimg');
			//			comtainer.onmouseenter = function() {
			//				swiper.stopAutoplay();
			//			};
			//			// 鼠标离开 继续轮播
			//			comtainer.onmouseleave = function() {
			//				swiper.startAutoplay();
			//			}
			//		var swiper = new Swiper('.swiper-container', {
			//				slidesPerView: 'auto',
			//				pagination: '.swiper-pagination',
			//			});
			window.addEventListener("scroll", this.watchScroll);
			var th = this
			window.onresize = function() { //监听屏幕的改变
				document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
			};
		},
		components: {

		}
	}
</script>
<style>
	@import url('../css/retrospect.css');
	@import url('../css/home.css');
	[v-cloak] {
		display: none !important;
	}
</style>
<style scoped>
	.flexb {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.flex {
		display: flex;
	}
	
	
	
	.TopNav {
		display: flex;
		/*height: 78px;*/
		width: 100%;
		height: 32px;
		flex-direction: row;
		justify-content: space-between;
		padding: 23px 0;
		box-shadow: 0px 14px 13px 0px rgba(112, 112, 149, 0.06);
	}
	
	.logo {
		width: 98px;
		height: 32px;
	}
	
	.logo_line {
		height: 28px;
		border: 1px solid #63686C;
		margin: 0 10px;
	}
	
	.nav_intro {
		color: #63686C;
		font-size: 14px;
		height: 28px;
		line-height: 18px;
		margin-top: -3px;
	}
	
	.logo1 {
		height: 25px;
		margin-top: 3px;
		margin-left: 15px;
		/*width: 94px;*/
	}
	
	.navBarWrap {
		position: fixed;
		top: 0px;
		z-index: 99999999999999999;
		background-color: #fff;
		width: 100%;
	}
	
	.wh {
		width: 100%;
		height: 910px;
		background-image: url(../../static/img/img_wh.png);
		background-size: 100% 100%;
		text-align: center;
	}
	
	.wh p {
		color: #fff;
		font-size: 28px;
		font-weight: bold;
		font-family: Microsoft YaHei;
		line-height: 46px;
	}
	
	.wh p:nth-child(1) {
		padding-top: 342px;
	}
	
	.jjfa {
		padding-top: 106px;
		padding-bottom: 140px;
		background: #fff;
		width: 1200px;
		margin: 0 auto;
		/*padding-left: 1.375rem;
		padding-right: 1.375rem;*/
	}
	
	.title {
		height: 36px;
		color: #323233;
		font-size: 36px;
		text-align: center;
		line-height: 36px;
	}
	
	.title1 {
		height: 30px;
		color: #323233;
		font-size: 30px;
		text-align: center;
		line-height: 30px;
	}
	
	.item {
		margin-top: 72px;
		/*width: 0.65rem;*/
		/*width: 274px;*/
		width: 164px;
		height: 262px;
		background: #FFFFFF;
		box-shadow: 0px 5px 35px 0px rgba(118, 181, 255, 0.17);
		border-radius: 10px;
		padding: 40px 55px;
		text-align: center;
		margin-bottom: 148px;
		margin-right: 40px;
	}
	
	.item img {
		height: 132px;
		margin: 0 auto;
	}
	
	.item p {
		margin-top: 50px;
		color: #131313;
		font-size: 16px;
		line-height: 25px;
	}
	
	.zhcz1 {
		width: 1200px;
		/*height: 1365px;*/
		padding-bottom: 98px;
		background: #FFFFFF;
		box-shadow: 0px 5px 35px 0px rgba(118, 181, 255, 0.17);
		margin: 0 8px;
	}
	
	.zhcz {
		margin-top: 120px;
		position: relative;
		margin-bottom: 84px;
	}
	
	.zhcz p {
		color: #141414;
		font-size: 18px;
		line-height: 27px;
		position: absolute;
		font-weight: 400;
	}
	
	.zhcz p:nth-child(2) {
		top: 85px;
		left: 170px;
	}
	
	.zhcz p:nth-child(3) {
		top: 80px;
		right: 265px;
	}
	
	.zhcz p:nth-child(4) {
		top: 270px;
		left: 260px;
	}
	
	.zhcz p:nth-child(5) {
		top: 225px;
		right: 380px;
	}
	
	.zhcz p:nth-child(6) {
		top: 490px;
		left: 105px;
	}
	
	.zhcz p:nth-child(7) {
		top: 295px;
		right: 240px;
	}
	
	.zhcz p:nth-child(8) {
		top: 360px;
		right: 205px;
	}
	
	.zhcz p:nth-child(9) {
		top: 460px;
		right: 220px;
	}
	
	.dzc {
		width: 100%;
	}
	
	.dzc img {
		margin: 0 auto;
		padding-top: 68px;
		margin-bottom: 100px;
	}
	
	.line {
		height: 1px;
		background: #EAEAEA;
		margin: 0 0.325rem;
	}
	
	.row {
		margin-left: 155px;
		margin-right: 150px;
		margin-top: 20px;
		/*display: flex;*/
	}
	
	.hxitem {
		width: 388px;
		height: 224px;
		background: #FFFFFF;
		border: 1px solid #99C8FF;
		border-radius: 0px 0px 6px 6px;
		background-image: url(../../static/img/img_bg_coreadvantage.png);
		background-size: 100% 100%;
		padding-left: 50px;
	}
	
	.hxitemtop {
		margin-top: 57px;
		height: 30px;
		line-height: 30px;
		color: #141414;
		font-size: 18px;
		line-height: 30px;
		font-weight: bold;
		margin-bottom: 38px;
	}
	
	.hxitemtop img {
		margin-right: 15px;
	}
	
	.hxitembottom {
		margin-top: 17px;
		font-size: 16px;
		color: #141414;
		height: 17px;
		line-height: 17px;
		margin-left: 40px;
	}
	
	.hxitembottom>div {
		width: 50%;
	}
	
	.yuan {
		width: 6px;
		height: 6px;
		background: #0276FF;
		border-radius: 50%;
		margin-top: 6px;
		margin-right: 10px;
	}
	
	.dp {
		width: 1200px;
		height: 690px;
		background: #FFFFFF;
		box-shadow: 0px 5px 35px 0px rgba(118, 181, 255, 0.17);
		margin: 0 8px;
		margin-top: 20px;
	}
	
	.dp img {
		margin: auto;
		padding-top: 104px;
	}
	
	.fw {
		/*width:100%;*/
		height: 495px;
		background: #F3F7FE;
		padding: 100px 0 85px 0;
		/*margin: 0 auto;*/
		/*padding: 100px 0 85px 0;*/
	}
	
	.fwitem {
		width: 330px;
		height: 389px;
		background: #FFFFFF;
		border-radius: 10px;
		margin-right: 50px;
	}
	
	.fwitem img {
		width: 154px;
		height: 154px;
		margin: 0 auto;
		margin-top: 33px;
	}
	
	.t {
		height: 23px;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #202020;
		line-height: 32px;
		margin: 25px 0;
		text-align: center;
	}
	
	.con {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #545F66;
		line-height: 24px;
		margin: 0 50px;
		text-align: center;
	}
	
	.bottom {
		height: 196px;
		background-image: url(../../static/img/img_bg_contactus.png);
		color: #fff;
		font-size: 24px;
		line-height: 196px;
		text-align: center;
		background-size: 100% 100%;
	}
	
	html,
	body {
		position: relative;
		height: 100%;
	}
	
	body {
		background: #eee;
		font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
		font-size: 14px;
		color: #000;
		margin: 0;
		padding: 0;
	}
	
	.fuwu li {
		width: 230px;
		text-align: center;
	}
	
	.fuwu li p {
		margin-top: 0;
	}
	
	.fuwu li .p1 {
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		margin-top: 21px;
		margin-bottom: 33px;
	}
	
	.yd .fuwu li .p1 {
		font-size: .32rem;
		color: rgba(51, 51, 51, 1);
		line-height: .32rem;
		margin-top: .2rem;
		margin-bottom: .24rem;
	}
	
	.fuwu li .p2 {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		line-height: 25px;
	}
	
	.yd .fuwu li .p2 {
		width: 5.04rem;
		font-size: .26rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(162, 162, 162, 1);
		text-align: center;
		line-height: .38rem;
		margin: 0 auto;
		text-align: center;
	}
	
	.yd .zuhe .iocBox li p {
		margin-top: 0;
		width: 100%;
		height: .26rem;
		line-height: .26rem;
		text-align: center;
		font-size: .06rem;
		box-sizing: border-box;
		font-family: Microsoft YaHei;
		border: 1px solid rgba(243, 246, 249, 1);
	}
	
	.yd .zuhe .iocBox li p {
		margin-top: 0;
		width: 100%;
		height: 0.93rem;
		line-height: 0.93rem;
		text-align: center;
		font-size: .28rem;
		box-sizing: border-box;
		font-family: Microsoft YaHei;
		border: 1px solid rgba(243, 246, 249, 1);
		background-color: #fff;
	}
	
	.yd .anli .iocBox li {
		margin-bottom: .3rem;
	}
	
	.anli .iocBox li {
		margin-bottom: .08rem;
	}
	
	.biaoti {
		/*font-size: .14rem;*/
		font-size: 36px!important;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-bottom: .29rem;
		text-align: center;
	}
	
	.yd footer {
		padding: .8rem .49rem;
		border: 2px solid rgba(28, 41, 70, 1);
	}
	
	.footerP {
		font-size: .24rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(164, 168, 176, 1);
	}
	
	.footerP .span1 {
		color: #fff;
	}
	
	.footerP .span2 {
		color: #00C59F;
	}
	
	.mb24 {
		margin-bottom: .24rem
	}
	
	.yd .biaoti {
		font-size: .44rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-bottom: .29rem;
		text-align: center;
		margin-bottom: .92rem;
	}
	
	.company_info {
		width: 4.3rem;
		margin: 0 auto;
		min-width: 1200px;
		height: 295px;
		color: #6f747e;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.company_info .company_infoDetail .company_infoDetail_logo {
		width: 153px;
		height: 50px;
		margin-bottom: 20px;
	}
	
	.company_info .company_infoDetail .company_infoDetail_text {
		margin-bottom: 12px;
	}
	
	.company_info .company_infoContect {
		display: flex;
	}
	
	.company_info .company_infoContect .company_infoContect_head {
		color: #ffffff;
		font-size: 18px;
		margin-bottom: 20px;
	}
	
	.company_info .company_infoContect .company_infoContect_title {
		margin-bottom: 12px;
	}
	
	.company_info .company_infoContect .company_infoContect_text {
		color: #ffffff;
		font-size: 20px;
		margin-bottom: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/elmmarket.vue